import { createComponent } from '@carvana/merch-components';

export const Content = createComponent('div', {
  className: 'flex flex-col gap-md'
});
